import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ErrorDelect"
});
const _hoisted_1 = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-828.000000, -486.000000)" fill="#E64C4C"><g transform="translate(580.000000, 486.000000)"><g transform="translate(248.000000, 0.000000)"><g transform="translate(2.079616, 2.079616)"><path d="M1.72287856,0.146446608 L5.98601875,4.40951894 L10.2491588,0.146446608 C10.429401,-0.0337953702 10.7130166,-0.0476601378 10.9091624,0.104852314 L10.9562657,0.146446608 L11.8255912,1.01577183 C12.0058334,1.19601373 12.0196982,1.47962926 11.8671852,1.67577482 L11.8255912,1.72287856 L7.56251892,5.98601875 L11.8255912,10.2491588 C12.0208523,10.4444211 12.0208523,10.7610037 11.8255912,10.9562657 L10.9562657,11.8255912 C10.7610037,12.0208523 10.4444211,12.0208523 10.2491588,11.8255912 L5.98601875,7.56251892 L1.72287856,11.8255912 C1.54263654,12.0058334 1.25902113,12.0196982 1.06287545,11.8671852 L1.01577183,11.8255912 L0.146446608,10.9562657 C-0.0337953702,10.7760238 -0.0476601378,10.4924086 0.104852314,10.2962628 L0.146446608,10.2491588 L4.40951894,5.98601875 L0.146446608,1.72287856 C-0.048815534,1.52761642 -0.048815534,1.21103397 0.146446608,1.01577183 L1.01577183,0.146446608 C1.21103397,-0.048815534 1.52761642,-0.048815534 1.72287856,0.146446608 Z" id="\u8DEF\u5F84"></path></g></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var errorDelect = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { errorDelect as default };
